<template>
  <nna-container :spacing=10>
    <div class="cart">
      <div class="product">
        <div class="qrcode">
          <img :src="`data:image/png;base64, ${qrcode}`" />
        </div>  
        <div class="text-align-cente muted mb-3">
          Da esibire all'esercente previa richiesta
        </div>
        <div class="md-layout md-gutter p-2 mb-0">
          <div class="md-layout-item text-align-left">
            <span class="label-muted">Ordine</span>            
            <div class="text-align-left text-color-primary mb-0"><strong>{{nameShop}}</strong></div>
            <div class="text-align-left">#{{orderNumber}}</div>
          </div>
          <div class="md-layout-item text-align-right">
            <span class="label-muted">Data</span>
            <div class="text-align-right">{{date}}</div>
          </div>
        </div>
        <nna-row v-for="detail in details" :key="detail.oid" class="pl-2 pr-2">  
          <nna-col align="left">   
            <div class="text-align-left">{{detail.product}}</div>
            <div class="text-align-left">{{detail.date}}</div>
          </nna-col>
          <nna-col align="right">
            <div class="muted text-align-left">{{detail.qty}}</div>
          </nna-col>        
          <nna-col align="right">
            <div class="text-color-primary orders__total text-color-primary">€{{detail.price}}</div>
          </nna-col>        
        </nna-row>      
        <div class="cart__total md-layout md-gutter p-2">
          <div class="md-layout-item text-align-left">
            <div class="cart__totalLabel">Totale</div>
          </div>
          <div class="md-layout-item text-align-right">
            <span class="label-muted">Pagamenti in contanti</span>
            <div class="cart__totalSum">€{{orderTotal}}</div>
          </div>
        </div>     
      </div>
      <div class="text-align-cente muted mb-3" v-if="registryMsg">
        {{registryMsg}}<br /><a class="covidLink" :href="registryLink" target="_blank">Compila registro</a>
      </div>
    </div> 
  </nna-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'OrderDetail',
  components: {
  },
  data() {
    return {
      shop_id: this.$route.params.id
    }
  },
  computed: {
    ...mapGetters({
      order: 'order/orderDetail',
    }),
    name() {
      return this.order && this.order.customer_info ? this.order.customer_info.name : ''
    },
    orderNumber() {
      return this.order ? this.order.number : ''
    },
    shop() {
      return this.order ? this.order.shop : ''
    }, 
    registryMsg() {
      return this.order ? this.order.registry_msg : ''
    }, 
    registryLink() {
      return this.order ? this.order.registry_link : ''
    }, 
    nameShop() {
      return this.order ? this.order.shop : ''
    },        
    orderTotal() {
      return this.order ? this.order.total.toFixed(1) : ''
    },
    date() {
      return this.order ? this.order.date : ''
    },
    hour() {
      return this.order ? this.order.date.substring(12) : ''
    },
    details() {
      return this.order ? this.order.details : []
    },  
    qrcode() {
      return this.order && this.order.qrcode ? this.order.qrcode.$binary : ''
    },        
  },
  methods: {
    ...mapActions({
      orderDetail: 'order/getOrder'
    }),
    async onShopDetail() {
      try { 
        const { data } = await this.shopDetail(this.shop_id)
        if(data.hcode === "ok") {
        } else {
          this.$router.back()
          this.$toasted.show(data.msg, { type: 'error' })
        }        
     } catch (errors) {
       console.error("Error:", errors)
       this.sending = false       
       this.$toasted.show('Qualcosa è andato storto!', { type: 'error' })
       this.$router.back()
      }      
    }
  },
  async mounted() {    
    await this.orderDetail(this.$route.params.id)
    console.log(this.order)
  },
  beforeDestroy() {
    
  },
}
</script>

<style lang="scss" scoped>
  .label-muted {
    font-size: 10px;
    font-weight: 300;
  }
  .table {
    padding: 0px 15px;
  }
  .cart__totalLabel {
    line-height: 42px;
  }
  .qrcode {
    img {
      width: 210px;
    }
  }
  .covidLink {
    font-size: 22px;
    line-height: 40px;
  }

  .container {
    padding-bottom: 66px !important;
  }
</style>



// WEBPACK FOOTER //
// src/modules/Order/pages/OrderDetail.vue